import { FormsFieldPreset, FormPlugin, FieldCollectionType } from '@wix/forms-common'
import { iconNames } from '../../icons/types'
import { CATEGORIES } from '../../../../../../panels/manage-fields-panel/constants/manage-fields-constants'
import { TextInput } from '../../fields-by-comp-type/definitions/text-input'
import { FieldRenderConfig } from '../../field-types-data'
import { ServerFieldType } from '../../../../../../constants/field-types'
import { FieldDataType } from '@wix/ambassador-contacts-v4-extended-field/types'

export const URL_REGEX = '^((https?|ftp)://)?[^\\s/$.?#]*\\.[^\\s]*$'

export class GeneralUrl extends TextInput {
  public get customFields() {
    return [FieldDataType.URL]
  }

  protected get icon() {
    return iconNames.website
  }

  public get collectionFieldType() {
    return FieldCollectionType.URL
  }

  public get serverType(): ServerFieldType {
    return ServerFieldType.URL
  }

  protected get data(): any {
    return {
      textType: 'url',
      pattern: URL_REGEX,
      placeholder: this.translate(`fieldTypes.${this.fieldType}.placeholderText`),
      type: 'TextInput',
      value: '',
    }
  }

  protected get props() {
    return {
      type: 'TextInputProperties',
      required: false,
    }
  }

  protected get renderConfig(): Partial<FieldRenderConfig> {
    return {
      [FormPlugin.FORM_BUILDER]: {
        addFieldPanelData: {
          category: CATEGORIES.url,
          subCategory: CATEGORIES.basic,
        },
      },
    }
  }

  public get fieldType(): FieldPreset {
    return FormsFieldPreset.GENERAL_URL
  }

  public get base() {
    return GeneralUrl.prototype
  }
}
